"use strict";

/* global translation */

jQuery(($) => {
    $(".uael-woo-products-summary-wrap a.krokedil-wishlist").mouseenter(function(e) {
        $(e.currentTarget).parent().siblings('.uael-woo-products-thumbnail-wrap').css('opacity', '0.5');
    });
    $(".suki-product-wrapper a.krokedil-wishlist").mouseenter(function(e) {
        $(e.currentTarget).siblings('.suki-product-thumbnail').css('opacity', '0.5');
    });

    $(".uael-woo-products-summary-wrap a.krokedil-wishlist").mouseleave(function() {
        $(e.currentTarget).parent().siblings('.uael-woo-products-thumbnail-wrap').css('opacity', '1');
    });
    $(".suki-product-wrapper a.krokedil-wishlist").mouseleave(function(e) {
        $(e.currentTarget).siblings('.suki-product-thumbnail').css('opacity', '1');
    });
});

const maksimer = {
    megaMenu: () => {
        const icons = document.querySelectorAll('.maksimer-hamburger');
        if (icons) {
            icons.forEach((icon) => {
                const link = icon.parentNode;
                const item = link.parentNode;
                item.classList.add('maksimer-mega-menu-item');
                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    item.classList.toggle('is-active');
                    icon.classList.toggle('is-active');
                })
            })
        }
    },
    headerSticky: () => {
        const container = document.querySelector('.site-header');
        if (container) {
            window.addEventListener('scroll', () => {
                if (document.documentElement.scrollTop > 100) {
                    container.classList.add('maksimer-sticky');
                } else {
                    container.classList.remove('maksimer-sticky');
                }
            });
        }
    },
    mobileMenuPopup: () => {
        const megaLinks = document.querySelectorAll(
            '.maksimer-menu-popup-link'
        );
        if (megaLinks) {
            megaLinks.forEach((megaLink) => {
                megaLink.addEventListener('click', () => {
                    document.body.classList.toggle(
                        'maksimer-menu-popup-active'
                    );
                });
            });
        }
    },
    megaMenuMobile: () => {
        const catArrows = document.querySelectorAll('.maksimer-mega-list h5 span');
        if (catArrows) {
            catArrows.forEach((arrow) => {
                arrow.addEventListener('click', (e) => {
                    e.preventDefault();
                    arrow.parentNode.parentNode.classList.toggle('active');
                });
            });
        }
    },
    productPriceSwitcher: () => {
        const container = document.querySelector('.maksimer-price');
        if (container) {
            const links = container.querySelectorAll('.maksimer-price-switcher > span');
            const prices = container.querySelectorAll('.maksimer-price-content > span')
            if (links && prices) {
                [...links].map((link, linkIndex) => {
                    link.addEventListener('click', () => {
                        [...links].map(el => el.classList.remove('--active'));
                        link.classList.add('--active');
                        [...prices].map((price, priceIndex) => {
                            if (priceIndex === linkIndex) {
                                price.classList.add('--active');
                            } else {
                                price.classList.remove('--active');
                            }
                        })
                    });
                });
            }
        }
    },
    cartNotices: () => {
        const container = document.querySelector('.woocommerce-cart');
        if (container) {
            const notices = container.querySelectorAll('.woocommerce-message');
            if (notices) {
                notices.forEach((notice) => {
                    const addedToCartNotice = notice.querySelector('.button.wc-forward');
                    if (addedToCartNotice) {
                        notice.style.display = 'none';
                    }
                })
            }
        }
    },
    wishlistSendMail: () => {
        const container = document.querySelector('#wishlist-options-buttons');
        if (container) {
            const mail = 'a';
            const wishlistLink = window.location.href;
            if (wishlistLink) {
                let nodeMail = document.createElement(mail);
                nodeMail.classList.add('maksimer-mail-wishlist', 'action-buttons', 'dashicons', 'dashicons-email');
                nodeMail.setAttribute('value', wishlistLink);
                container.appendChild(nodeMail);
            }
            const sendMail = document.querySelector('.maksimer-mail-wishlist');
            if (sendMail) {
                sendMail.addEventListener('click', (e) => {
                    e.preventDefault();
                    jQuery.post(translation.ajaxurl, {
                        action: 'maksimer_ajax_wishlist_mail',
                        wishlist_link: wishlistLink,
                    }, (response) => {
                        let data;
                        try { data = jQuery.parseJSON(response); } catch (err) {
                            console.log(`Problem parsing json string : ${response}`); // eslint-disable-line no-console
                            return null;
                        }
                        alert(data);
                        return null;
                    });
                });
            }
        }
    },
    wishlistBuyAllButtonClone: () => {
        const btn = document.querySelector('.maksimer-add-to-cart');
        if (btn) {
            const container = document.querySelector('.wishlist-container')
            container.prepend(btn.cloneNode(true));
        }
    },
    wishlistShareLinkReplace: () => {
        const linkHolder = document.querySelector('#link-holder');
        if (linkHolder) {
            if (linkHolder.getAttribute('value')) {
                linkHolder.setAttribute('value', window.location.href);
            }
        }
    }
};

maksimer.megaMenu();
maksimer.headerSticky();
maksimer.mobileMenuPopup();
maksimer.megaMenuMobile();
maksimer.productPriceSwitcher();
maksimer.cartNotices();
maksimer.wishlistSendMail();
maksimer.wishlistBuyAllButtonClone();
maksimer.wishlistShareLinkReplace();

/**
 * Listening for when nodes are added to the DOM, such as Elementor popups.
 */
document.body.addEventListener('DOMNodeInserted', (e) => {
    maksimer.megaMenuMobile();
});

/**
 * When Elementor popup is removed from the DOM, this removes the mega menu active class on the body tag.
 */
document.body.addEventListener('DOMNodeRemoved', () => {
    document.body.classList.remove('maksimer-menu-popup-active');
    maksimer.megaMenuMobile();
});